import styled from "styled-components"
import { LogoClaims, SettingsIcon, UserIcon } from "../assets/icons/Icons"
import { Link } from "react-router-dom"
import { MenuIcon } from "../assets/icons/Icons"
import { useAuth } from "../redux/authReducer"
import { useLazyQuery } from "@apollo/client"
import { LOGOUT } from "../services/auth"
import { useEffect, useState } from "react"


const Wrapper = styled.div`
  width: 100vw;
  background-color: #fff;
  display: flex;
  place-content: center;
  box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 12px;
  z-index: 9;
  position: fixed;
  top: 0;
`

const Container = styled.div`
  padding: 6px 0px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  @media only screen and (max-width: 1280px) {
    padding: 6px 10px;
  } ;
`

const StyledButton = styled.button`
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: var(--primary-royal-blue);
  font-weight: 500;
  font-size: 14px;
  @media only screen and (max-width: 500px) {
    text-align: left;
    margin-top: 10px;
    font-size: 16px;
  }
`

const OptionsContainer = styled.div`
  display: flex;
  gap: 60px;
  @media only screen and (max-width: 500px) {
    gap: 10px;
    display: none;
  } ;
`

const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const MenuMobileWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 500px) {
    display: flex;
    align-items: center;
    width: 150px;
    justify-content: flex-end;
  } ;
`

const MenuMobileBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  margin-top: 125px;
  background-color: white;
  padding: 12px;
  border-radius: 4px;
`

export default function Navbar() {
  const { logout } = useAuth()
  const [doLogOut, resultsLogOut] = useLazyQuery(LOGOUT)
  const [openMenu, setOpenMenu] = useState(false)

  const handleLogOut = () => {
    doLogOut()
  }

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu)
  }
  useEffect(() => {
    if (resultsLogOut?.data?.logout?.statusCode === 200) logout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resultsLogOut])
  return (
    <Wrapper>
      <Container>
        <Link to="/">
          <LogoClaims />
        </Link>
        <OptionsContainer>
          <OptionContainer>
            <SettingsIcon />
            <Link to="/catalogos">
              <StyledButton>Catálogos</StyledButton>
            </Link>
          </OptionContainer>
          <OptionContainer>
            <UserIcon />
            <StyledButton onClick={handleLogOut}>Cerrar sesión</StyledButton>
          </OptionContainer>
        </OptionsContainer>
        <MenuMobileWrapper>
          <div  onClick={handleOpenMenu} >
          <MenuIcon />
          </div>
          {openMenu && (
            <MenuMobileBox>
              <StyledButton onClick={handleLogOut}>Cerrar sesión</StyledButton>
              <Link to="/catalogos">
              <StyledButton>Catálogos</StyledButton>
              </Link>
            </MenuMobileBox>
          )}
        </MenuMobileWrapper>
      </Container>
    </Wrapper>
  )
}
